<template>
  <section
    class="product-summary"
    aria-label="Сводка по товарам"
  >
    <dl class="product-summary__list">
      <div
        v-for="metric in metrics"
        :key="metric.label"
        class="product-summary__item">

        <dt class="product-summary__title">
          <span class="product-summary__metric-icon">
            <component
              :is="metric.icon"
              :size="20"
            />
          </span>

          {{ metric.label }}
        </dt>

        <dd class="product-summary__value">
          {{ getValue(metric) }}
        </dd>
      </div>
    </dl>
  </section>
</template>

<script>
import {
  Package,
  Boxes,
  PackageX,
  Tags,
  Wallet,
  Banknote
} from 'lucide-vue'
import { priceToFormat } from '@/helper'

export default {
  name: 'ProductSummary',
  props: {
    products: {
      type: Array,
      default: () => []
    },
    unavailable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    stockTotals () {
      return this.products.reduce((totals, row) => {
        const count = Math.max(0, Number(row.count) || 0)
        const purchasePrice = Number(row.purchasePrice) || 0
        const salePrice = Number(row.salePrice) > 0 ? Number(row.salePrice) : Number(row.price) || 0

        totals.purchase += count * purchasePrice
        totals.sale += count * salePrice

        return totals
      }, { purchase: 0, sale: 0 })
    },
    metrics () {
      return [
        {
          label: 'Товарных позиций',
          value: this.products.length,
          icon: Package
        },
        {
          label: 'Единиц в наличии',
          value: this.products.reduce((sum, { count }) => sum + Math.max(0, Number(count) || 0), 0),
          icon: Boxes
        },
        {
          label: 'Нет в наличии',
          value: this.products.filter(({ count }) => count != null && Number(count) <= 0).length,
          icon: PackageX
        },
        {
          label: 'Со скидкой',
          value: this.products.filter(({ salePrice }) => Number(salePrice) > 0).length,
          icon: Tags
        },
        {
          label: 'Стоимость остатков по закупочной цене',
          value: this.stockTotals.purchase,
          currency: true,
          icon: Wallet
        },
        {
          label: 'Стоимость остатков по цене продажи',
          value: this.stockTotals.sale,
          currency: true,
          icon: Banknote
        }
      ]
    }
  },
  methods: {
    getValue (metric) {
      return this.unavailable ? '—' : metric.currency ? priceToFormat(metric.value) : metric.value
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
